<template>
  <div id="cooperativePartner"> 
    <Navigation/>
    <div class="container-fluid container_fluid">
      <div class="row fluid_row">
        <div class="col-md-12 _Modular">
          <div class="col-md-12">
            <div class="right_border"></div>
            <div class="col-md-12 right_cont_title">合作伙伴</div>
            <div class="col-md-12 right_cont_slogan">强强联合打造顶尖产品</div>
          </div>
          <div class="col-md-12 right_cont_content">
            <p class="right_cont_p">上海岐素科技与各高等院校、医疗机构、企事业单位合作,以完善的中医药养生诊疗体系服务大众。上海岐素欢迎各位合作伙伴。公司现有业务健康干预综合体、人才培养、科研成果转化、产业基地共建、食品农产品安全检测等。打造中国顶尖的健康食品产业集群,推动中国特色养生食品、安全食品走进国际市场。</p>
          </div>
          <div class="col-md-8 Partner">
            <div class="Partner_dvs" v-for="(parts,id) in partnerList" :key="id">
              <div class="col-md-12 Partner_div">
                <img :src="parts.imag" class="parts_image">
                <span class="span_name">{{parts.name}}</span>
              </div>
            </div>

          </div>
        </div>
      </div>

    </div>
    <ReturnTop/>
    <HeadTail/>
  </div>
</template>

<script>
import navigation from './publicComponent/Navigation'
import headTail from './publicComponent/HeadTail'
import returnTop from './publicComponent/ReturnTop'
export default {
  data(){
    return{
      partnerList:[
        {imag:'../../static/image/PartnerImage/1.png', name:"黑龙江中医药大学",},
        {imag:'../../static/image/PartnerImage/2.png',name:"上海中医药大学",}
      ],

    }
  },
  created(){
    // this.flag = 0
    // if(document.body.clientWidth > 750){
    //   this.CompanyTop = '../../static/image/CompanyProfileImage/contentImage.png'
    //   this.CompanyIdea = '../../static/image/CompanyProfileImage/webIdea.png'
    // }else{
    //   this.CompanyTop = '../../static/image/CompanyProfileImage/appContentImage.png'
    //   this.CompanyIdea = '../../static/image/CompanyProfileImage/appIdea.png'
    // }
  },
  methods:{
    //   choseprofrom:function (id) {
    //     this.flag = id;
    //   }
  },
  components: {
    'HeadTail': headTail,  //将别名demo 变成 组件 Demo
    "Navigation":navigation,
    "ReturnTop" : returnTop 
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@media screen and (min-width: 750px){
    .fluid_row{
      margin-top: 11vh !important;
    }
    .right_border{
      width: 12vw;
      height: 7vw;
      position: absolute;
      border: 10px solid #ebeced;
      left: 23%;
      top: 2.2vw;
    }
    .right_cont_title{
      font-size: 2.5vw;
      color: #0047ab;
      padding-left: 18% !important;
      padding-top: 3% !important;
      font-weight: 600;
    }
    .right_cont_slogan{
      font-size: 1.5vw;
      font-weight: 600;
      padding-left: 18.2% !important;
    }
    .right_cont_p{
      padding-top: 4vw !important;
      padding-left: 18% !important;
      padding-right: 24% !important;
      font-size: 0.95vw;
    }
    .Partner{
      margin-top: 8vh !important;
      margin-left: 18% !important;
      display: flex;
      justify-content: space-between;
      margin-bottom: 5% !important;
      flex-wrap: wrap;
    }
    .Partner_dvs{
      /* border: 1px solid; */
      box-shadow: 2px 1px 13px 5px #f1f1f1;
      width: 48%;
      height: 10vw;
      margin-bottom: 2vw !important;
    }
    .Partner_div{
      display: flex;
      align-items: center;
      height: 10vw;
      /* justify-content: space-around; */
    }
    .parts_image{
      width: 5vw;
      margin-left: 15% !important;
    }
    .span_name{
      font-size: 1.2vw;
      margin-left: 10% !important;
    }
}

/* 移动端特殊样式 */
@media screen and (max-width: 750px){
    .container-fluid{
      margin-top: 12% !important;
    }
    .right_border{
      width: 29vw;
      height: 18vw;
      position: absolute;
      border: 6px solid #ebeced;
      left: 13%;
      top: 6%;
      z-index: -1;
    }
    .right_cont_title{
      font-size: 6vw;
      color: #0047ab;
      padding-left: 2% !important;
      padding-top: 3% !important;
      font-weight: 600;
    }
    .right_cont_slogan{
      font-size: 4vw;
      font-weight: 600;
      padding-left: 2% !important;
    }
    .right_cont_p{
      padding-top: 4vh !important;
      font-size: 11pt;
      padding-left: 2% !important;
      padding-right: 2% !important;
      text-align: justify;
    }

    .Partner{
      margin-top: 4vw !important;
      display: flex;
      justify-content: space-between;
      margin-bottom: 5% !important;
      flex-wrap: wrap;
      padding-left: 2% !important;
      padding-right: 2% !important;
    }
    .Partner_dvs{
      /* border: 1px solid; */
      box-shadow: 2px 1px 13px 5px #f1f1f1;
      width: 48%;
      height: 18vw;
      margin-bottom: 2vw !important;
    }
    .Partner_div{
      display: flex;
      align-items: center;
      height: 18vw;
      /* justify-content: space-around; */
    }
    .parts_image{
      width: 12vw;
      margin-left: 6% !important;
    }
    .span_name{
      font-size: 3.6vw;
      margin-left: 6% !important;
    }
}

</style>



// WEBPACK FOOTER //
// src/components/CooperativePartner.vue